import type { MenuDataItem } from '@wix/editor-elements-definitions';
import { reportError } from '../../../../../common/sdk/reporters';
import { InvalidMenuDepthError } from '../errors';

export const validateMenuItemsDepth =
  (maxLevels: number) =>
  (value: Array<MenuDataItem>): boolean => {
    if (!value) {
      return true;
    }

    const checkMenuItemsLevel = ({
      currentLevel,
      items,
    }: {
      items?: Array<MenuDataItem>;
      currentLevel: number;
    }): boolean => {
      if (!items) {
        return true;
      }

      if (items.length === 0) {
        return true;
      } else if (currentLevel < 0) {
        return false;
      }

      return items.every(({ menuItems, label, link }) => {
        const hasMenuItems = typeof menuItems !== 'undefined';

        if (!hasMenuItems) {
          return true;
        }

        const isValidMenuItems = checkMenuItemsLevel({
          items: menuItems,
          currentLevel: currentLevel - 1,
        });

        if (!isValidMenuItems) {
          throw new InvalidMenuDepthError(maxLevels + 1, label || link || '');
        }

        return isValidMenuItems;
      });
    };

    return value.every(({ menuItems, label, link }) => {
      try {
        const result = checkMenuItemsLevel({
          items: menuItems,
          currentLevel: maxLevels - 1,
        });

        if (result === false) {
          throw new InvalidMenuDepthError(maxLevels + 1, label || link || '');
        }
      } catch (error: any) {
        reportError(error.message);
        return false;
      }
      return true;
    });
  };
